export default "__VITE_ASSET__BEznZoDt__"